module.exports = __webpack_public_path__ + "static/manabu-mobile-ce6a67ca7589a0a364bc5bacae55ec87.png";